import React from 'react';
import OverlayMessage from './OverlayMessage';

const Error = (props) => {
  return <OverlayMessage {...props} iconName="Error" />;
};

export default Error;



// WEBPACK FOOTER //
// ./src/app/components/MessageOverlay/Error.jsx